/// <amd-module name="TFS/Admin/Common/Util/CommonTestUtilities" />
import { ICustomIdentityRef } from "TFS/Admin/Common/Contracts/CustomIdentityRef";

export class CommonTestUtilities {
    public static getContextMock() {
        return {
            pageContext: {
                getService: () => {
                    return {
                        getIdentityImageUrl: () => null
                    };
                }
            }
        };
    }

    public static getCustomIdentityRefMock(isUser: boolean = true): ICustomIdentityRef {
        let random: number = Math.floor(Math.random() * 50) + 1;

        return {
            id: this.generateGuid(),
            displayName: "Test Identity User" + random,
            preferredEmailAddress: "dummy" + random + "microsoft.com",
            imageUrl: "",
            isUser: isUser
        };
    }

    public static generateGuid() {
        var sGuid = "";
        for (var i = 0; i < 32; i++) {
            sGuid += Math.floor(Math.random() * 0xf).toString(0xf);
        }
        return sGuid;
    }
}
